export default __webpack_public_path__ + "img/port arthur.8b3851f2.jpg";